import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles({
	listRoot: {
		padding: 0,
		alignItems: "flex-start",
		"&.MuiListItem-root.Mui-selected": {
			backgroundColor: "#fff",
		},
	},
	radioRoot: {
		padding: "8px 5px",
	},
	note: {
		maxWidth: "272px",
		fontSize: "14px",
		padding: "0 32px",
		color: "#969392",
	},
	clearFilter: {
		marginLeft: "32px",
		fontSize: "14px",
		fontWeight: 600,
		color: "#367bf5",
		cursor: "pointer",
	},
	boxList: {
		padding: "16px 0",
	},
	openCustom: {
		marginTop: 6,
		height: 100,
	},
	textField: {
		paddingLeft: "8px",
		"& .MuiInputBase-root.Mui-disabled": {
			color: "#212121",
		},
	},
	textFieldSelected: {
		paddingLeft: "8px",
		"& .MuiInputBase-root.Mui-disabled": {
			color: "#367bf5",
			fontWeight: 600,
		},
	},
	monthText: {
		"&:hover": {
			color: "#fff",
		},
	},
	monthDatePicker: {
		"&:hover": {
			background: "#083D9B !important",
			color: "#fff !important",
		},
	},
});
